import React from "react";
import MetaTags from "react-meta-tags";

function PaymentAppSuccess(props) {
  return (
    <div>
      <MetaTags>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      </MetaTags>
      <div>Thanh toán thành công</div>
    </div>
  );
}

export default PaymentAppSuccess;
